<template>
  <div v-wechat-title="$route.meta.title" class="selectCustomer">
    <div class="back" @click="isShowSelected = true">
      <span>切换门店</span>
      当前门店
    </div>
    <div style="height:40px"></div>
    <div class="customerTop">
      <div class="carImg">
        <img src="../assets/icon/car_icon.png" alt="">
      </div>
      <div class="row r1">{{CompanyName}}</div>
      <div class="row">{{IndexStore.state.Vin}}</div>
      <div class="row">{{IndexStore.state.CarTypeName}}</div>
      <div style="clear:both"></div>
    </div>
    <div class="main">
      <div class="search">
        <van-search v-model="searchValue" placeholder="请输入客户名称" @search="onSearch" @input="onSearch" @clear="onClear"></van-search>
      </div>
      <van-list v-model="loading" @load="onLoad" :finished="finished" finished-text="没有更多了">
        <customerList :list="list"/>
      </van-list>
    </div>
    <van-popup class="panel" v-model="isShowSelected" position="left" :style="{ height: '100%', width: '70%' }">
      <div>
        <ul>
          <li v-for="(item, index) in orgList" :key="index" @click="selectItem(item)" :class="item.checked?'cur':''">
            {{item.PositionShopName}}
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { List, Toast } from "vant";
import util from "../utils/util";

import api from "../services/api";
import feach from "../utils/axiosp";
import IndexStore from "../store/Index";
import customerList from "../components/customerList.vue";

import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Col,
  Row,
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Index from "../store/Index";

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Search);

export default {
  name: "selectCustomer",
  components: { customerList },
  computed: {
    
  },
  data() {
    return {
      IndexStore,
      searchValue: "",
      list: [],
      loading: true,
      finished: false,
      OrgId: 0,
      pageSize: 10,
      pageNo: 0,
      orgList:[],
      isShowSelected:false,
    };
  },
  computed:{
    CompanyName: () => IndexStore.state.CompanyName,
  },
  async created() {
    sessionStorage.removeItem('warehouseOutData');
    localStorage.removeItem('CustomerID');
    localStorage.removeItem('EmployeeMobile');
    this.OrgId = localStorage.getItem("OrgId") || 0;
    sessionStorage.setItem("selectCustomerUrl", location.href);
  },
  beforeRouteEnter(to, from, next){ 
　　　　console.log("from",from)

　　　　next((vm) => { 
        if(from.name=='activityBills'){
          location.reload()
        }
          
　　　　})
　},
  async mounted() {
    await this.getOrgList();
    this.onLoad();
  },
  methods: {
    async onLoad() {
      this.getCustomerList()
    },
    selectItem(data){
      this.orgList.forEach((item,index)=>{
        item.checked = false;
      })
      data.checked = true;
      this.isShowSelected = false;
      this.pageNo = 0;
      this.list = [];
      this.OrgId = data.OrgId;
      IndexStore.setState("CompanyName", data.OrganizationName);
      localStorage.setItem("OrgId", data.OrgId);
      localStorage.setItem("PostionID", data.PostionID);
      this.getCustomerList();
    },
    // 获取列表
    async getCustomerList() {
      this.loading = true;
      console.log(this.OrgId);
      let res = await api.getCustomerList({
        OrgId: this.OrgId,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        keyWord:this.searchValue
      });
      if(res.Data.length>0){
        res.Data.forEach((item,index)=>{
          this.list.push(item);
        })
        this.pageNo++;
      }else{
        this.finished = true;
      }
      this.loading = false;
    },
    //获取组织列表
    async getOrgList(){
      let res = await api.getOrgList();
      let tag = true;

      if(res.Data){
        res.Data.forEach((item,index)=>{
          if(localStorage.getItem("PostionID")){
            if(localStorage.getItem("PostionID")==item.PostionID){
              item.checked = true;
              this.OrgId = item.OrgId;
              localStorage.setItem("OrgId", item.OrgId);
              localStorage.setItem("PostionID", item.PostionID);
              IndexStore.setState("CompanyName", item.OrganizationName);
            }else{
              item.checked = false;
            }
          }else{
            if(index==0){
              item.checked = true;
              this.OrgId = item.OrgId;
              localStorage.setItem("OrgId", item.OrgId);
              localStorage.setItem("PostionID", item.PostionID);
              IndexStore.setState("CompanyName", item.OrganizationName);
            }else{
              item.checked = false;
            }
          }
          this.orgList.push(item)
        })
      }
    },
    onClear(){
      //IndexStore.setKeyword().search()
      //IndexStore.setKeyword('').search()
    },
    toDinghuoMini(activeId){
      let DMSCode = util.getStoObj("allinfo").DMSCode;
      let UserId = util.getStoObj("allinfo").UserId;
      let ShopCode = util.getStoObj("allinfo").ShopCode;
      let mobile = util.getStoObj("allinfo").LegalPersonPhone;
      let token = util.getStoObj("urlQuery").QPT_UserToken;
      let OrgText = util.getStoObj("allinfo").OrgText;
      let Eshop_Name = util.getStoObj("allinfo").UserName;
      let actId = activeId || 0;
      // wx.miniProgram.navigateTo({
      //   url: `../middlePage/middlePage?DMSCode=${DMSCode}&UserId=${UserId}`,
      // });
      if(actId>0){
        location.href=`${basedata.dinghuoUrl}/#/actInfo?ActivityId=${actId}&Eshop_DMSCode=${DMSCode}&Eshop_ShopCode=${ShopCode}&tab=2&isApp=0&UserType=0&Eshop_Name=${Eshop_Name}&Eshop_Company=${OrgText}&Eshop_Mobile=${mobile}&Eshop_UserToken=${token}&PlatformType=13&isfrom=jiqiren`
      }else{
        location.href=`${basedata.dinghuoUrl}/#/?Eshop_DMSCode=${DMSCode}&Eshop_ShopCode=${ShopCode}&tab=2&isApp=0&UserType=0&Eshop_Name=${Eshop_Name}&Eshop_Company=${OrgText}&Eshop_Mobile=${mobile}&Eshop_UserToken=${token}&PlatformType=13&isfrom=jiqiren`
      }
      
    },
    onSearch(){
      this.list= [];
      this.pageNo = 0;
      this.finished = false;
      setTimeout(() => {
        this.getCustomerList();
      }, 500);
      
    },
    
  },
};
</script>

<style lang="scss" scoped>
.selectCustomer{
  background: #F6F6F6;
  padding:10px;
  .back{
    text-align: center;
    height: 40px;
    background: #4FAE54;
    position: fixed;
    left:0;
    top:0;
    width: 100%;
    z-index: 100;
    line-height: 40px;
    color: #fff;
    font-size: 0.28rem;
    span{
      margin-right: 5px;
      vertical-align: top;
      position: fixed;
      left:10px;
      top:0px;
    }
  }
}
.panel{
  padding:10px 0;
  li{
    display: flex;
    align-items: center;
    padding:10px;
    font-size: 0.26rem;
    border-bottom: 1px solid #eee;
    &.cur{
      color: #4FAE54;
    }
  }
}
.main{
  border-radius: 5px;
  background: #fff;
}
.customerTop{
  background: #fff;
  padding:10px;
  border-radius: 5px;
  margin-bottom: 10px;
  .row{
    color: #666;
  }
  .r1{
    font-size: 0.3rem;
    font-weight: bold;
    margin-bottom:5px;
    color: #333;
  }
  .carImg{
    float: left;
    margin-right: 0.3rem;
    img{
      width: 1.82rem;
      height: 1.07rem;
    }
  }
}
.selectCustomer{
  font-size: 0.24rem;
}
.title{padding: 10px}
</style>
<style lang="scss">
.selectCustomer{
  .van-search{
    background:none;
    border-bottom:1px solid #eee
  }
}
</style>